const USER_FEATURE_FLAGS = [
  {
    key: 'creatorFloatingCreate',
    label: 'Experimental creator navigation',
    sublabel: 'Preview the floating creator navigation and Create button in supported app builds for eligible internal test accounts.'
  },
  {
    key: 'useNewOpportunities',
    label: 'Opportunities Redesign',
    sublabel: 'Redesigned opportunities experience on the creator surface — the brand surface is enabled for everyone'
  },
  {
    key: 'disableForgotPassword',
    label: 'Disable Forgot Password',
    sublabel: 'Hides the password reset controls in account settings for this user, used to lock down an account being actively phished'
  },
  {
    key: 'allowAgentConnections',
    label: 'Allow agent connections',
    sublabel: 'Let external AI agents (Claude, ChatGPT) sign in via MCP and act on your behalf',
    editableByAccountOwner: true
  },
  {
    key: 'useInstagramQuickConnect',
    label: 'Instagram Quick Connect',
    sublabel:
      'Connect Instagram through Instagram Login instead of the Facebook popup while the global Quick Connect switch is off. When the switch is on, every creator connects this way and this toggle shows on regardless'
  },
  {
    key: 'momentShops',
    label: 'Search and admin Moment previews',
    sublabel:
      'Enable conversational search with Atelier and vibe ranking. All active accounts can use Moments in the app without this flag; web browsing and editing are limited to flagged admin previews. Shared web links stay viewable.'
  },
  {
    key: 'creatorAdPlatforms',
    label: 'Creator ad platforms',
    sublabel: 'Shows the TikTok announcement popup in mobile app builds that still check it. Web shows it to every Meta-onboarded creator.'
  },
  {
    key: 'useSmartDm',
    label: 'Smart DM',
    sublabel:
      'The Smart DM page (Feed · DMs · Analytics · Settings) and the connect-a-post entry points on links and collections. Setting it up asks Instagram for the comment + message scopes sending requires; until Meta approves them, only accounts with a role on the Instagram Login app can grant them'
  },
  {
    key: 'useCreatorSales',
    label: 'Sales updated sales in promotion tab',
    sublabel: 'Enables updated Sales in mobile app builds that still check this flag. Web Sales is available to every active creator.'
  },
  {
    key: 'newGiftingOffersTab',
    label: 'Gifting Priority / General lanes',
    sublabel:
      'Splits the mobile Gifting tab (iOS 2.2.37+) into Priority and General pills using the lane the server stamps on each offer. Pills only appear once the creator has offers in both lanes; the web Gifting tab is unchanged'
  },
  {
    key: 'useNotificationCenter',
    label: 'Notification Center',
    sublabel:
      'The notification center and its icon badge. The badge is the center unread count plus Partners tasks, and pushes stop incrementing the icon for this user. A brand\'s note on a collaboration proposal or acceptance stops marking the chat unread.'
  },
  {
    key: 'useCollaborationsV2',
    label: 'Collaborations Redesign',
    sublabel:
      'Redesigned collaborations hub and collaboration page on the creator surface. On for everyone; switch off to return this user to the legacy pages. The brand surface has its own switch on the brand feature flags panel.',
    defaultOn: true
  },
  {
    key: 'useNewEditLinkModal',
    label: 'Edit Link Modal Redesign',
    sublabel:
      'The redesigned two-column modal when a creator edits an existing link, with the collection picker. On by default for admins who can manage users. Off returns this user to the legacy Edit your product overlay; adding a new link is unchanged',
    defaultOnForAdmins: true
  },
  {
    key: 'commissionRateDrawer',
    label: 'Commission rate breakdown',
    sublabel:
      'Rate lines on links open the commission rate breakdown (popover on web, drawer in the iOS app) instead of the (i) disclaimer sentence. Off returns this user to the legacy disclaimer tooltip'
  },
  {
    key: 'allowRetailerDomainSettings',
    label: 'Allowed retailer domain settings',
    sublabel: 'Let this creator edit allowed retailer domains in Advanced settings. Admins can always edit them.'
  }
];

const canEditUserFeatureFlag = (key, { isAccountOwner = false, isUnrestrictedAdmin = false } = {}) => {
  const flag = USER_FEATURE_FLAGS.find(flag => flag.key === key);
  return !!flag && (isUnrestrictedAdmin || (isAccountOwner && flag.editableByAccountOwner === true));
};

module.exports = {
  USER_FEATURE_FLAGS,
  canEditUserFeatureFlag
};
